import dayjs from 'dayjs';

import { useNavigate } from 'hooks';
import { Flex } from 'components/flex';
import { Icon } from 'components/icon';
import { useAppDispatch } from 'store';
import { Button } from 'components/button';
import { ButtonColors, ListCardStyle } from 'types';
import { markAsRead } from 'store/slices/notifications';

import * as Styles from './styles';
import { NotificationCardProps } from './types';

const getRelativePath = (fullUrl: string): string => {
  try {
    const url = new URL(fullUrl);
    return url.pathname + url.search + url.hash;
  } catch {
    return fullUrl;
  }
};

export const NotificationCard = ({
  close,
  isDialog,
  showDivider,
  notification,
}: NotificationCardProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userTimezone = dayjs.tz.guess();

  return (
    <Styles.StyledListCard
      padding="16px"
      template="1fr"
      isOdd={isDialog}
      mobileTemplate="1fr"
      tabletTemplate="1fr"
      key={notification.id}
      showDivider={showDivider}
      odd={isDialog ? ListCardStyle.Default : undefined}
      values={[
        <Flex column gap={8}>
          <Flex gap={8} alignItems="center">
            {!notification.isRead && <Styles.UnreadDot />}

            <Styles.Title>{notification?.payload?.title}</Styles.Title>
          </Flex>
          <p>{notification?.payload?.text}</p>

          <Flex gap={8} alignItems="center" justifyContent="space-between">
            <Styles.Time>
              {dayjs(notification?.createdAt).tz(userTimezone).fromNow()}
            </Styles.Time>

            <Flex gap={4}>
              <Button
                padding="0"
                transparent
                icon={<Icon.Checkmark />}
                colorType={ButtonColors.BlackWhite}
                tooltip={`Mark as ${notification?.isRead ? 'unread' : 'read'}`}
                onClick={() =>
                  dispatch(
                    markAsRead({
                      id: notification.id,
                      readStatus: !notification?.isRead,
                    })
                  )
                }
              />
              {notification?.payload?.link && (
                <Button
                  padding="0"
                  transparent
                  tooltip="View Details"
                  icon={<Icon.NavigationLeft />}
                  colorType={ButtonColors.BlackWhite}
                  onClick={() => {
                    const relativePath = getRelativePath(
                      notification.payload.link!
                    );

                    navigate(relativePath);
                    close?.();
                  }}
                />
              )}
            </Flex>
          </Flex>
        </Flex>,
      ]}
    />
  );
};
